import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import format from 'date-fns/format';
import { Create, PreviewIcon } from '../../components/Icons/Icon';
import Pagination from '../../components/Pagination/Pagination';
import CustomTable from '../../components/Table/Table';
import GridItem from '../../components/Grid/GridItem';
import Snackbar from '../../components/Snackbar/Snackbar';
import Typography from '../../components/Typography/CustomTypography';
import WrapperContainer from '../../components/Container/WrapperContainer';
import styles from '../../assets/jss/pages/productManagementPageStyle';
import DialogEditSeminar from './DialogEditSeminar';
import DialogDetailSeminar from './DialogDetailSeminar';
import ProgessDialog from '../../components/Dialog/ProgessDialog';
import Loader from '../../components/Loader/Loader';

import { convertDuration } from '../../utils/dateUtils';
import { SEMINAR_STATUS_CHECK } from '../../common/Constants';
import CustomTextSelector from '../../selectors/CustomText';

const useStyles = makeStyles(styles);
const ActionRow = ({
    onEdit, disabled, onPreview, requireDisable, noAction,
}) => {
    const classes = useStyles();
    const disableCheck = requireDisable || disabled;
    return (
        <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap" width="100%">
            <GridItem style={{ display: 'flex' }}>
                <IconButton onClick={onEdit} disabled={disabled}>
                    <Create />
                </IconButton>
                <IconButton onClick={(disableCheck) ? noAction : onPreview} className={disableCheck && classes.disableHover} disableRipple={disableCheck}>
                    <PreviewIcon color={(disabled || requireDisable) && 'rgba(0, 0, 0, 0.26)'} />
                </IconButton>
            </GridItem>
        </Box>
    );
};

const ListSeminar = (props) => {
    const {
        fetchListSeminar,
        listSeminar,
        seminars,
        clearDetailSeminar,
        errors,
        getDetailCompany,
        detailCompany,
        eventInfo,
        clearDetailComopany,
        detailSeminar,
        getDetailSeminar,
        updateSeminar,
        updateSeminarSuccess,
        isLoading,
        isFetchingUpdate,
        percent,
        clearListSeminar,
        clearUpdateSeminar,
        token,
    } = props;
    const classes = useStyles();
    const intl = useIntl();
    const routeParams = useParams();
    const history = useHistory();
    const [viewerList, setViewerList] = useState([]);
    const [currentPage, setCurrentPage] = useState();
    const [isOpenDialogDetail, setIsOpenDialogDetail] = useState(false);
    const [isOpenDialogEdit, setIsOpenDialogEdit] = useState(false);
    const [snackbar, setSnackbar] = useState({ isOpen: false, type: 'success', message: '' });
    const [detailSeminarState, setDetailSeminarState] = useState({});
    const customText = useSelector(CustomTextSelector.createGetCustomText());

    useEffect(() => {
        const { shortName } = routeParams;
        getDetailCompany();
        fetchListSeminar({ shortName, page: 1, page_size: 20 });
        return () => {
            clearDetailComopany();
            clearListSeminar();
            clearUpdateSeminar();
        };
    }, [routeParams]);

    useEffect(() => {
        if (updateSeminarSuccess) {
            const { shortName } = routeParams;
            fetchListSeminar({ shortName, page: currentPage, page_size: 20 });
            setSnackbar({ isOpen: true, type: 'success', message: 'Update Success' });
            setIsOpenDialogEdit(false);
            clearDetailSeminar();
        }
    }, [updateSeminarSuccess]);

    useEffect(() => {
        setDetailSeminarState({ ...detailSeminar });
    }, [detailSeminar]);

    useEffect(() => {
        if (errors && errors.code === 'BAD_REQUEST') {
            if ((errors.message && errors.message.message) || errors?.non_field_errors?.message) {
                setSnackbar({
                    ...snackbar,
                    isOpen: true,
                    type: 'error',
                    message: errors?.message?.message || errors?.non_field_errors?.message,
                });
            }
        }
    }, [errors]);

    useEffect(() => {
        if (listSeminar && listSeminar.length > 0) {
            const tableData = listSeminar.map((seminar) => {
                const img = seminar.speaker_img && seminar.speaker_img.concat('?=', new Date().getTime().toString());
                const status = getSeminarStatus(seminar.is_paused, seminar.is_deleted);
                const requireCheck = seminar.content && seminar.title && seminar.speaker && seminar.media && seminar.limit;
                return [
                    format(new Date(seminar.date), 'yyyy/MM/dd'),
                    `${seminar.stime}~${seminar.etime}`,
                    seminar.title,
                    seminar.speaker,
                    seminar.speaker_img && <div className={classes.thumbnailImage} style={{ backgroundImage: `url('${img}')` }} />,
                    seminar.content,
                    convertDuration(
                        seminar.media_duration,
                        intl.formatMessage({ id: 'common.hour' }),
                        intl.formatMessage({ id: 'common.minute' }),
                        intl.formatMessage({ id: 'common.second' }),
                    ),
                    status.MSG,
                    <ActionRow
                        onEdit={(e) => handleEditInTable(e, seminar.id)}
                        onPreview={(e) => handlePreview(e, seminar.id)}
                        noAction={(e) => { e.stopPropagation(); }}
                        size="sm"
                        disabled={status.CODE === SEMINAR_STATUS_CHECK.DELETED.CODE || status.CODE === SEMINAR_STATUS_CHECK.PAUSED.CODE}
                        requireDisable={!requireCheck}
                    />,
                ];
            });
            setViewerList(tableData);
        }
    }, [listSeminar]);

    const getSeminarStatus = (isPaused, isDeleted) => {
        if (isPaused && isDeleted) {
            return SEMINAR_STATUS_CHECK.DELETED;
        }
        if (!isPaused && !isDeleted) {
            return SEMINAR_STATUS_CHECK.NORMAL;
        }
        if (isDeleted) {
            return SEMINAR_STATUS_CHECK.DELETED;
        }
        return SEMINAR_STATUS_CHECK.PAUSED;
    };

    const handlePreview = (e, id) => {
        e.stopPropagation();
        const { shortName } = routeParams;
        const path = `/${shortName}/seminar-management/${id}?is_preview=true`;
        history.push(path);
    };

    const handleEditInTable = (e, id) => {
        e.stopPropagation();

        const index = listSeminar.findIndex((item) => item.id === id);

        if (index !== -1 && listSeminar[index].is_paused) {
            setSnackbar({
                ...snackbar,
                isOpen: true,
                type: 'error',
                message: '一時停止状態でセミナーを閲覧できません。',
            });

            return;
        }

        setIsOpenDialogEdit(true);
        getDetailSeminar(id);
    };

    const handleEditInDetail = (id) => {
        setIsOpenDialogDetail(false);
        setIsOpenDialogEdit(true);
        getDetailSeminar(id);
    };

    const handleSearchWithPage = (page) => {
        setCurrentPage(page);
        if (fetchListSeminar) {
            const { shortName } = routeParams;
            fetchListSeminar({
                event_name: shortName,
                page_size: 20,
                page,
            });
        }
    };
    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, isOpen: false });
    };

    const handleShowDialogDetail = (index) => {
        // Get seminar status, check if is disabled
        if (viewerList[index][7] === SEMINAR_STATUS_CHECK.PAUSED.MSG || viewerList[index][7] === SEMINAR_STATUS_CHECK.DELETED.MSG) {
            return;
        }

        if (listSeminar[index].is_paused) {
            setSnackbar({
                ...snackbar,
                isOpen: true,
                type: 'error',
                message: '一時停止状態でセミナーを閲覧できません。',
            });

            return;
        }

        setIsOpenDialogDetail(true);

        if (listSeminar[index] && listSeminar[index].id) {
            getDetailSeminar(listSeminar[index].id);
        }
    };

    const handleCloseDialogEdit = () => {
        clearDetailSeminar();
        setIsOpenDialogEdit(false);
    };
    const handleCloseDialogDetail = () => {
        setIsOpenDialogDetail(false);
        clearDetailSeminar();
    };

    return (
        <>
            <Loader isLoading={isLoading} />
            <WrapperContainer className={classes.wrapper}>
                <GridItem xs={12}>
                    <Box paddingBottom={4} paddingTop={4}>
                        <Typography bold variant="h4" color="info" align="center">
                            {customText?.content?.screen_name?.seminar_info_management || 'セミナー情報管理'}
                        </Typography>
                    </Box>
                    <Typography bold>
                        <ul>
                            <li>出展者</li>
                            <ul>
                                <li>
                                    社名：
                                    {detailCompany.fullName}
                                </li>
                                <li>
                                    代表者：
                                    {`${detailCompany.firstName} ${detailCompany.lastName}`}
                                </li>
                            </ul>
                        </ul>
                    </Typography>
                    <CustomTable
                        onClick={(index) => handleShowDialogDetail(index)}
                        tableHead={[
                            <>{customText?.content?.field_name?.dates || '開催日'}</>,
                            <>{customText?.content?.field_name?.time || '時間'}</>,
                            <>{customText?.content?.field_name?.lecture_name || '講演名'}</>,
                            <>{customText?.content?.field_name?.speaker || '講演者'}</>,
                            <>{customText?.content?.field_name?.speaker_photo || '講演者写真'}</>,
                            <>{customText?.content?.field_name?.lecture_content || '講演内容'}</>,
                            <>{customText?.content?.field_name?.playback_time || '再生時間'}</>,
                            <>{customText?.content?.field_name?.situation || '状況'}</>,
                            <>{customText?.content?.field_name?.action || 'アクション'}</>,
                        ]}
                        tableHeadWidth={['10%', '15%', '15%', '10%', '10%', '10%', '10%', '10%', '10%']}
                        tableData={viewerList}
                        tableFooter={(
                            <Box display="flex" justifyContent="center">
                                <Pagination
                                    page={seminars.page}
                                    total={seminars.total_page}
                                    onChange={(page) => handleSearchWithPage(page)}
                                />
                            </Box>
                        )}
                    />
                    <DialogEditSeminar
                        isOpen={isOpenDialogEdit}
                        handleClose={handleCloseDialogEdit}
                        detailSeminar={detailSeminarState}
                        eventName={eventInfo.name}
                        handleEditSeminar={updateSeminar}
                        errors={errors}
                        eventInfo={eventInfo}
                    />
                    <DialogDetailSeminar
                        isOpen={isOpenDialogDetail}
                        handleClose={handleCloseDialogDetail}
                        datailSeminar={detailSeminarState}
                        eventName={eventInfo.name}
                        handleEditInDetail={handleEditInDetail}
                        updateSeminarSuccess={updateSeminarSuccess}
                        percent={percent}
                        token={token}
                        eventInfo={eventInfo}
                    />
                </GridItem>
            </WrapperContainer>
            <Snackbar
                open={snackbar.isOpen}
                onClose={handleCloseSnackbar}
                message={snackbar.message}
                severity={snackbar.type}
            />
            <ProgessDialog isOpen={isFetchingUpdate} percent={percent} />
        </>
    );
};

ListSeminar.defaultProps = {
    listSeminar: [],
    seminars: {},
    errors: {},
    eventInfo: {},
    detailCompany: {},
    detailSeminar: {},
    updateSeminarSuccess: false,
    isFetchingUpdate: true,
    percent: 0,
    token: '',
};

ListSeminar.propTypes = {
    fetchListSeminar: PropTypes.func.isRequired,
    clearDetailSeminar: PropTypes.func.isRequired,
    getDetailCompany: PropTypes.func.isRequired,
    clearDetailComopany: PropTypes.func.isRequired,
    getDetailSeminar: PropTypes.func.isRequired,
    updateSeminar: PropTypes.func.isRequired,
    clearListSeminar: PropTypes.func.isRequired,
    clearUpdateSeminar: PropTypes.func.isRequired,
    updateSeminarSuccess: PropTypes.bool,
    listSeminar: PropTypes.oneOfType([() => null, PropTypes.array]),
    seminars: PropTypes.oneOfType([() => null, PropTypes.object]),
    detailSeminar: PropTypes.oneOfType([() => null, PropTypes.object]),
    errors: PropTypes.oneOfType([() => null, PropTypes.object]),
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    detailCompany: PropTypes.oneOfType([() => null, PropTypes.object]),
    isLoading: PropTypes.bool.isRequired,
    isFetchingUpdate: PropTypes.bool,
    percent: PropTypes.number,
    token: PropTypes.string,
};

ActionRow.propTypes = {
    onEdit: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    onPreview: PropTypes.func.isRequired,
    requireDisable: PropTypes.bool.isRequired,
    noAction: PropTypes.func.isRequired,
};

export default ListSeminar;
